export default __webpack_public_path__ + "static/Studio-To-Sea-Sub-Banner-Desktop-d5748574db8549df160b8e8e76b91b78.webp";